const $ = jQuery;

const initTogglers = ()=>{
	$('body').on('click', '[data-toggle-active]', function(){
		const target = $(this).attr('data-toggle-active');
		const bodyClass = target.replace('.', '').replace('#', '')+'--toggled';
		if ($(target).length){
			$(target).toggleClass('active');
			$('body').toggleClass(bodyClass);
		}
	});
}

export default initTogglers;